import { UserBookPreference, UserPreference } from "./utils";

function createSelector<T>(sliceName) {
  return (state, key: T) => state.preferences[sliceName][key]?.value;
}

export const getUserPref = createSelector<UserPreference>("user");
export const getUserBookPref = createSelector<UserBookPreference>("book");
